/* eslint no-template-curly-in-string: 0 */ // --> OFF

/*

    If you want to use a custom config when running locally you can add a file on root level named CashierConfigLocal.js
    CashierConfigExample.js can be used as a template
    If that file exists it will be used instead of the default configuration below.
    That file is gitignored and will therefore not be version handled by git.

*/

const merge = require('deepmerge')

// This needs to be a var, not let since this is used by webpack and therefore not transpiled by babel. Old browsers that doesn't understand let/const will break otherwise
var config
var defaultConfig = {
  production: {
    PIQ_API_PATH: 'https://api.paymentiq.io',
    DID_API_PATH: 'https://api.gii.cloud',
    DID_CLIENT_PATH: 'https://api.gii.cloud',
    // DID_CLIENT_ID: 'bambora_prod', // moved to config
    DID_REDIRECT_URI: 'https://pay.paymentiq.io'
  },

  test: {
    PIQ_API_PATH: 'https://test-api.paymentiq.io',
    DID_API_PATH: 'https://api.gii.cloud',
    DID_CLIENT_PATH: 'https://api.gii.cloud',
    // DID_CLIENT_ID: 'bambora-demo',
    // DID_CLIENT_ID: 'bambora_prod',
    DID_REDIRECT_URI: 'https://pay.paymentiq.io'
  },

  development: {
    PIQ_API_PATH: 'https://test-api.paymentiq.io',
    // DID_API_PATH: 'http://localhost:4000',
    // DID_API_PATH: 'https://demo-api.gii.cloud',
    DID_API_PATH: 'https://api.gii.cloud',
    DID_CLIENT_PATH: 'https://demo-api.gii.cloud',
    // DID_CLIENT_ID: 'bambora-demo',
    // DID_CLIENT_ID: 'bambora-demo',
    DID_REDIRECT_URI: 'http://localhost:4000',
    port: '4000',
    proxy: {
      '/api/oauth': {
        // target: 'https://demo-api.gii.cloud',
        target: 'https://demo-api.gii.cloud',
        //  target: 'http://localhost:8080',
        secure: false,
        changeOrigin: true
      }
    }
  }
}

try {
  config = merge(defaultConfig, require('./PaymentIQCheckoutClientConfigLocal'))
} catch (ex) {}

if (!config) {
  try {
    // If there's no localConfig, use the default one.
    config = defaultConfig
  } catch (ex) {}
}

// export default config
module.exports = config
